import { render, staticRenderFns } from "./multipleDeleteDialog.vue?vue&type=template&id=25fd3dbd"
import script from "./multipleDeleteDialog.vue?vue&type=script&lang=js"
export * from "./multipleDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./multipleDeleteDialog.vue?vue&type=style&index=0&id=25fd3dbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports